module.exports = __webpack_public_path__ + "img/fact_check.0df9588d.svg";